import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISaveListeningSessionV1Request } from './save-listening-session-v1-request';
import type { ISaveListeningSessionV1Response } from './save-listening-session-v1-response';
import { saveListeningSessionV1ResponseSchema } from './save-listening-session-v1-response';

export async function saveListeningSessionV1Api(
  body: ISaveListeningSessionV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ISaveListeningSessionV1Response>> {
  return postRequest<ISaveListeningSessionV1Response>({
    path: '/listening/session/v1',
    body,
    schema: saveListeningSessionV1ResponseSchema,
    options,
  });
}
